import { render } from "./main.vue?vue&type=template&id=2519c9ca&scoped=true&ts=true"
import script from "./main.vue?vue&type=script&lang=ts&config=true"
export * from "./main.vue?vue&type=script&lang=ts&config=true"

import "./main.vue?vue&type=style&index=0&id=2519c9ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2519c9ca"]])

export default __exports__